module.exports = __webpack_public_path__ + "img/toscana-mobile.364408a8.jpg";